import {GetInstantOfferAdsError} from './GetInstantOfferAdsError.js'

export class GetInstantOfferNotFoundAdsError extends GetInstantOfferAdsError {}
